import mammoth from "mammoth";

/** Map Word w:jc values to synthetic style names mammoth styleMap can target. */
export function alignmentStyleName(
  alignment: string | null | undefined,
): string | null {
  if (!alignment) return null;
  switch (alignment) {
    case "center":
      return "__lexgat_align_center";
    case "right":
      return "__lexgat_align_right";
    case "both":
    case "distribute":
    case "thaidistribute":
      return "__lexgat_align_justify";
    case "left":
      return "__lexgat_align_left";
    default:
      return null;
  }
}

/**
 * Mammoth reads w:jc into paragraph.alignment but does NOT emit text-align in HTML.
 * Tag aligned paragraphs so styleMap can output p.center / p.justify classes.
 */
export function transformDocumentForAlignment(document: {
  children?: unknown[];
  [key: string]: unknown;
}) {
  const transforms = (
    mammoth as unknown as {
      transforms: {
        paragraph: (
          fn: (paragraph: Record<string, unknown>) => Record<string, unknown>,
        ) => (doc: typeof document) => typeof document;
      };
    }
  ).transforms;

  return transforms.paragraph((paragraph) => {
    const alignStyle = alignmentStyleName(
      paragraph.alignment as string | null | undefined,
    );
    if (!alignStyle) return paragraph;

    return {
      ...paragraph,
      styleName: alignStyle,
      styleId: alignStyle,
    };
  })(document);
}
